import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import { getLangState } from '../../store/lang.slice';
import { ReportAbuseWrapper, ReportHeader, ReportContent } from './styles';
import FullLogo from '../../assets/images/svg/FullLogo.svg';

export default function ReportAbuseSuccess() {
  const { formatMessage } = useIntl();
  const langType = useSelector(getLangState);
  const [searchParams] = useSearchParams();
  const message =
    searchParams.get('message') ||
    formatMessage({ id: 'reportAbuse.successMessage' });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <ReportAbuseWrapper lang={langType}>
      <ReportHeader lang={langType}>
        <div className="header-content">
          <img src={FullLogo} alt="Jadwalh" className="logo" />
          <h1>{formatMessage({ id: 'reportAbuse.successTitle' })}</h1>
        </div>
      </ReportHeader>

      <ReportContent lang={langType}>
        <div
          className="success-content"
          style={{
            padding: '0px 20px',
            direction: langType === 'ar' ? 'rtl' : 'ltr',
          }}
        >
          <p
            style={{
              fontSize: '16px',
              color: '#666',
              textAlign: langType === 'ar' ? 'right' : 'left',
            }}
          >
            {message}
          </p>
        </div>
      </ReportContent>
    </ReportAbuseWrapper>
  );
}
